import { Building2, Mail, Phone, MapPin } from 'lucide-react';

interface CompanyCardProps {
  company: {
    logo?: string;
    logoBase64?: string;
    commercialName?: string;
    legalName?: string;
    email?: string;
    phone?: string;
    address?: string;
  };
}

export default function CompanyCard({ company }: CompanyCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <div className="flex items-start gap-6">
        {/* Company Logo */}
        <div className="flex-shrink-0">
          {(company.logo || company.logoBase64) ? (
            <img
              src={company.logoBase64 || company.logo}
              alt={`${company.commercialName || company.legalName} logo`}
              className="w-24 h-24 object-contain rounded-lg"
            />
          ) : (
            <div className="w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center">
              <Building2 className="w-12 h-12 text-gray-400" />
            </div>
          )}
        </div>

        {/* Company Info */}
        <div className="flex-grow">
          <h3 className="text-xl font-semibold text-gray-900">
            {company.commercialName || company.legalName}
          </h3>
          {company.commercialName && company.legalName && (
            <p className="text-sm text-gray-600 mt-1">{company.legalName}</p>
          )}
          
          <div className="mt-4 space-y-2">
            {company.email && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Mail className="w-4 h-4" />
                <a href={`mailto:${company.email}`} className="hover:text-blue-600">
                  {company.email}
                </a>
              </div>
            )}
            
            {company.phone && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Phone className="w-4 h-4" />
                <a href={`tel:${company.phone}`} className="hover:text-blue-600">
                  {company.phone}
                </a>
              </div>
            )}
            
            {company.address && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <MapPin className="w-4 h-4" />
                <span>{company.address}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
